/*!
 * @Author: leo
 * @Date: 2020-02-07 19:21:00
 * @Last Modified by: leo
 * @Last Modified time: 2020-02-07 19:21:00
 * @Instruduction: bug服务接口
 */

import xhr from './xhr/index'

interface IBugListParams {
    type?: number         // 类型
    status?: number       // 状态
    news_id?: number
    page_index?: number    // 第几页
    page_size?: number     // 每页条数
}

interface IUpdateBugParams {
    id: number   // bug ID
    memo?: string,
    status?: number
}

interface IAddBugParams {
    news_id: number   // 新闻 ID
    data: object[]    // bug 类型以及备注信息
}

class BugService {
    /** 获取bug列表数据 */
    public async getList(params: IBugListParams) {
        const result = await xhr({
            method: 'get',
            url: '/bug/list',
            params: params 
        })
        return result
    }

    /** 更新bug状态 */
    public async update(params: IUpdateBugParams) {
        const result = await xhr({
            method: 'put',
            url: '/bug',
            params: params 
        })
        return result
    }

    /** 添加bug */
    public async add(params: IAddBugParams) {
        const result = await xhr({
            method: 'post',
            url: '/bug',
            params: params 
        })
        return result
    }
}

// 实例化后导出，全局单例
export default new BugService()
